// import axios from 'axios';
// import React, { useEffect, useState } from 'react';
// import { Button, Card, notification, Spin, Skeleton } from 'antd';

// const InterviewNotifications = ({ isNotificaitonLoading, setIsNotificaitonLoading }) => {
//     const [interviewNotifications, setInterviewNotifications] = useState([]);
//     const [hasFetched, setHasFetched] = useState(false);

//     const fetchNotificationsForInterview = async () => {
//         setIsNotificaitonLoading(true);
//         try {
//             let { data } = await axios.get('/getInterviewNotifications');
//             setInterviewNotifications(data?.interviewDetail || []);
//             setHasFetched(true);
//             notification.success({ message: 'Notifications loaded successfully!' });
//         } catch (error) {
//             console.error('Error fetching notifications:', error);
//             notification.error({ message: 'Failed to load notifications', description: error.message });
//         } finally {
//             setIsNotificaitonLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchNotificationsForInterview();
//     }, []);

//     return (
//         <div>
//             <Card title="Interview Notifications" style={{ width: 400, height: 500, overflowY: 'auto' }}>
//                 {isNotificaitonLoading ? (
//                     <>
//                         <Skeleton active paragraph={{ rows: 8 }} />
//                         <Skeleton active paragraph={{ rows: 2 }} />
//                     </>
//                 ) : (
//                     <>
//                         {interviewNotifications.length > 0 ? (
//                             <ul style={{ listStyle: 'none', padding: 0, marginTop: 10 }}>
//                                 {interviewNotifications.map((notif, index) =>{ 
//                                     if (notif === null) {
//                                         return;
//                                     }
//                                    return <li key={index} style={{ borderBottom: '1px solid #ddd', padding: '8px 0' }}>
//                                         <strong>Interviewee:</strong> {notif.interviwee} <br />
//                                         <strong>Position:</strong> {notif.position} <br />
//                                         <strong>Application Date:</strong> {notif.applicationData} <br />
//                                         <strong>Status:</strong> {notif.status}
//                                     </li>
//                                 })}
//                             </ul>
//                         ) : (
//                             <p style={{ marginTop: 10, textAlign: 'center' }}>No new notifications</p>
//                         )}
//                         <Button onClick={fetchNotificationsForInterview} type="primary" block>
//                             Refresh
//                         </Button>
//                     </>
//                 )}
//             </Card>
//         </div>
//     );
// };

// export default InterviewNotifications;



import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Button, Card, notification, Spin, Badge, Empty, Space, Typography, Tag, Tooltip, Popconfirm } from 'antd';
import { BellOutlined, ReloadOutlined, CheckOutlined, CheckCircleOutlined, DeleteOutlined } from '@ant-design/icons';
const { Text, Title } = Typography;
const NotificationComponent = ({ unreadCount, setUnreadCount, fetchNotifications, notifications = [], setNotifications, hasFetched, isNotificationLoading }) => {
   
    const markAsRead = async (notificationId) => {
        try {
            const { data } = await axios.patch('/notifications/read', {
                notificationIds: [notificationId]
            });
            if (data.success) {
                // Update local state
                setNotifications(prevNotifications =>
                    prevNotifications.map(notif =>
                        notif._id === notificationId
                            ? { ...notif, isRead: true, readAt: new Date() }
                            : notif
                    )
                );
                setUnreadCount(prev => Math.max(0, prev - 1));
            }
        } catch (error) {
            console.error('Error marking notification as read:', error);
            notification.error({
                message: 'Failed to mark as read',
                description: error.response?.data?.message || error.message,
                duration: 2
            });
        }
    };
    
    const markAllAsRead = async () => {
        try {
            const { data } = await axios.patch('/notifications/read-all');
            if (data.success) {
                // Update all notifications to read
                setNotifications(prevNotifications =>
                    prevNotifications.map(notif => ({
                        ...notif,
                        isRead: true,
                        readAt: new Date()
                    }))
                );
                setUnreadCount(0);
                notification.success({
                    message: 'All notifications marked as read',
                    duration: 2
                });
            }
        } catch (error) {
            console.error('Error marking all as read:', error);
            notification.error({
                message: 'Failed to mark all as read',
                description: error.response?.data?.message || error.message,
                duration: 2
            });
        }
    };
    
    const getNotificationTypeColor = (type) => {
        const colors = {
            leave_request: 'blue',
            leave_approval: 'green',
            overtime_request: 'orange',
            overtime_approval: 'cyan',
            attendance_issue: 'red',
            salary_slip: 'purple',
            system_announcement: 'magenta',
            general: 'default'
        };
        return colors[type] || 'default';
    };
    
    const formatDate = (date) => {
        const now = new Date();
        const notifDate = new Date(date);
        const diffInMs = now - notifDate;
        const diffInMinutes = Math.floor(diffInMs / 60000);
        const diffInHours = Math.floor(diffInMs / 3600000);
        const diffInDays = Math.floor(diffInMs / 86400000);
        if (diffInMinutes < 1) return 'Just now';
        if (diffInMinutes < 60) return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
        if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
        if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
        return notifDate.toLocaleDateString();
    };

    const deleteNotification = async (notificationId) => {
        try {
            const { data } = await axios.delete('/notifications/delete', {
                data: { notificationIds: [notificationId] }
            });

            if (data.success) {
                // Remove deleted notification from state
                setNotifications(prev => prev.filter(n => n._id !== notificationId));
                setUnreadCount(prev => Math.max(0, prev - 1));
                notification.success({
                    message: 'Notification deleted',
                    duration: 2
                });
            }
        } catch (error) {
            console.error('Error deleting notification:', error);
            notifications.error({
                message: 'Failed to delete notification',
                description: error.response?.data?.message || error.message,
                duration: 2
            });
        }
    };
    
    return (
        <div className="p-6 max-w-4xl mx-auto" style={{ height: '600px', overflowY: 'auto' }}>
            <div className="flex justify-between items-center mb-6">
                <div className="flex items-center gap-3">
                    {/* <Badge count={unreadCount} overflowCount={99}>
                        <BellOutlined style={{ fontSize: '24px' }} />
                    </Badge> */}
                    {/* <Title level={3} style={{ margin: 0 }}>
                        Notifications
                    </Title> */}
                </div>
                <Space>
                    {unreadCount > 0 && (
                        <Button
                            icon={<CheckCircleOutlined />}
                            onClick={markAllAsRead}
                            type="default"
                        >
                            Mark All as Read
                        </Button>
                    )}
                    <Button
                        icon={<ReloadOutlined />}
                        onClick={() => fetchNotifications(true)}
                        loading={isNotificationLoading}
                        type="primary"
                    >
                        Refresh
                    </Button>
                </Space>
            </div>
            {!hasFetched ? (
                <div className="text-center py-12">
                    <Spin size="large" tip="Loading notifications..." />
                </div>
            ) : (
                <>
                    {notifications.length > 0 ? (
                        <div className="space-y-3">
                            {notifications.map((notif) => {
                                if (!notif) return null;
                                return (
                                    <Card
                                        key={notif._id}
                                        className={`transition-all hover:shadow-md ${!notif.isRead ? 'border-l-4 border-l-blue-500 bg-blue-50' : ''
                                            }`}
                                        bodyStyle={{ padding: '16px' }}
                                    >
                                        <div className="flex justify-between items-start gap-4">
                                            <div className="flex-1">
                                                <div className="flex items-center gap-2 mb-2">
                                                    <Tag color={getNotificationTypeColor(notif.notificationType)}>
                                                        {notif.notificationType.replace('_', ' ').toUpperCase()}
                                                    </Tag>
                                                    {!notif.isRead && (
                                                        <Badge status="processing" text="New" />
                                                    )}
                                                </div>
                                                <Title level={5} style={{ margin: '0 0 8px 0' }}>
                                                    {notif.title}
                                                </Title>
                                                <Text type="secondary" style={{ display: 'block', marginBottom: '8px' }}>
                                                    {notif.message}
                                                </Text>
                                                {notif.createdBy && (
                                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                                        From: {notif.createdBy.name || notif.createdBy.email || 'System'}
                                                    </Text>
                                                )}
                                                <div style={{ marginTop: '8px' }}>
                                                    <Text type="secondary" style={{ fontSize: '12px' }}>
                                                        {formatDate(notif.createdAt)}
                                                    </Text>
                                                </div>
                                            </div>
                                            <div className="flex items-center gap-2">
                                                {!notif.isRead && (
                                                    <Tooltip title="Mark as read">
                                                        <Button
                                                            type="text"
                                                            icon={<CheckOutlined />}
                                                            onClick={() => markAsRead(notif._id)}
                                                            size="small"
                                                        />
                                                    </Tooltip>
                                                )}
                                                <Popconfirm
                                                    title="Are you sure you want to delete this notification?"
                                                    onConfirm={() => deleteNotification(notif._id)}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Tooltip title="Delete notification">
                                                        <Button
                                                            type="text"
                                                            danger
                                                            icon={<DeleteOutlined />}
                                                            size="small"
                                                        />
                                                    </Tooltip>
                                                </Popconfirm>
                                            </div>
                                        </div>
                                    </Card>
                                );
                            })}
                        </div>
                    ) : (
                        <Card>
                            <Empty
                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                description="No notifications yet"
                            />
                        </Card>
                    )}
                </>
            )}
       </div>
    );
};
export default NotificationComponent;